var ThirdPartyDevicesComponentController = (function () {
    function ThirdPartyDevicesComponentController(locationService) {
        this.locationService = locationService;
    }
    ;
    ThirdPartyDevicesComponentController.prototype.$onChanges = function (onChangesObj) {
        if (onChangesObj.includedDevices && Array.isArray(onChangesObj.includedDevices.currentValue)) {
            this.devices = this.includedDevices.slice();
        }
    };
    ThirdPartyDevicesComponentController.prototype.onDevicesSelected = function (devices) {
        this.showAddMoreDevices = false;
        var _loop_1 = function (device) {
            if (this_1.devices.some(function (d) { return d.searchKey === device.searchKey; })) {
                return "continue";
            }
            this_1.devices.push(device);
        };
        var this_1 = this;
        for (var _i = 0, devices_1 = devices; _i < devices_1.length; _i++) {
            var device = devices_1[_i];
            _loop_1(device);
        }
        if (this.onDevicesChange) {
            this.onDevicesChange({ devices: this.devices.slice() });
        }
    };
    ThirdPartyDevicesComponentController.prototype.excludeDevice = function (device) {
        var deviceIndex = this.devices.indexOf(device);
        if (this.devices.length === 1 || deviceIndex === -1) {
            return;
        }
        this.devices.splice(deviceIndex, 1);
        if (this.onDevicesChange) {
            this.onDevicesChange({ devices: this.devices.slice() });
        }
    };
    ThirdPartyDevicesComponentController.prototype.deviceName = function (device) {
        return device.manufacturer + " " + device.name;
    };
    ThirdPartyDevicesComponentController.prototype.newSearchUrl = function () {
        return this.locationService.build('compatibilityguide');
    };
    ThirdPartyDevicesComponentController.$inject = ['locationService'];
    return ThirdPartyDevicesComponentController;
}());
export var ThirdPartyDevicesComponent = {
    bindings: {
        excludedDevices: '<?',
        includedDevices: '<',
        onDevicesChange: '&?',
        scrollable: '<?',
    },
    controller: ThirdPartyDevicesComponentController,
    templateUrl: 'compatibilityguide/ng-templates/feature/search/thirdpartydevices',
};
